import { gql } from '@apollo/client'

export const GET_USER_CALENDAR_QUERY = gql`
  query getUserCalendar {
    getUserCalendar {
      calendarS3Url
    }
  }
`

export interface UserCalendarData {
  getUserCalendar: {
    calendarS3Url: string
  }
}
